import { ENV } from "../env";
/**
 * Shared auth/me fetch with in-flight deduplication and short-lived cache.
 */

export const AUTH_ME_URL =
  ENV.VITE_AUTH_ME_URL ||
  "https://hami-middleware.paziresh24.com/v1/auth/me";

export function parseAuthMeUser(data) {
  if (!data) return null;
  return (
    (Array.isArray(data?.users) && data.users[0]) ||
    data?.user ||
    data?.data ||
    null
  );
}

export function getUserRemoteId(user) {
  if (!user) return null;
  const id = user.remote_id ?? user.id;
  return id != null ? id : null;
}

export function getUserDisplayName(user) {
  if (!user) return "کاربر";
  const name = user.name || user.full_name || user.email || "کاربر";
  const family = user.family || "";
  return `${name} ${family}`.trim() || "کاربر";
}

export function isAuthMeAdmin(user) {
  if (!user) return false;
  const rawIsAdmin = user.is_admin;
  return (
    rawIsAdmin === true ||
    rawIsAdmin === 1 ||
    rawIsAdmin === "1" ||
    rawIsAdmin === "true" ||
    user.roles?.includes?.("admin") ||
    user.roles?.includes?.("support_admin")
  );
}

let authMeCache = null;
let authMeInFlight = null;

/** @returns {Promise<object|null>} parsed user object or null */
export function fetchAuthMe({ force = false } = {}) {
  if (!force && authMeCache !== null) {
    return Promise.resolve(authMeCache);
  }
  if (!force && authMeInFlight) {
    return authMeInFlight;
  }

  authMeInFlight = fetch(AUTH_ME_URL, { credentials: "include" })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const user = parseAuthMeUser(data);
      authMeCache = user;
      return user;
    })
    .catch(() => {
      authMeCache = null;
      return null;
    })
    .finally(() => {
      authMeInFlight = null;
    });

  return authMeInFlight;
}

export function invalidateAuthMeCache() {
  authMeCache = null;
  authMeInFlight = null;
}
